import React, {Component,Fragment} from 'react';
import './newSubject.scss';
import $ from 'jquery';
import API from './../../config/api';
import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';
import Header from "../../components/Header/header";
import {Toast} from 'antd-mobile';
import AppBtn from "../../components/AppBtn/appBtn";
import TopBtn from "../../components/TopBtn/topBtn";
import DetailBtn from "../../components/DetailBtn/detailBtn";
import { withRouter } from 'react-router-dom';

const TYPE = {
	NEW: 'NEW'
}


// 新专题
@connect(
	state => ({admin: state.admin}),
	{refresh_admin}
)

class Subject extends Component {
	constructor(props) {
		super(props);
		this.state = {
			specialFocusUrl: props.match.params.special_focus_url,
			data: {},
			uuid: '',
			type: TYPE.NEW,
			name: 'newSpecial',
			lisId : '',
			paixuBoolue: false,
			haveLive: false,
			video_cover: '',
		};
		this.liveSource = React.createRef(); // 创建 ref
   		this.livePlayer = React.createRef(); // 创建 ref
	}

	componentWillMount() {
		$('html,body').css({
			'background-color': '#F4F4F4'
		})
		// 获取内容id
		this.getContentId(this.props);
		// 获取内容
		this.getContent();
		// 统计
		this.statistics();
	}

	componentDidMount() {
		this.setVideoUrl()
		this.control()
		this.initSwiper() //设置轮播图
		// 获取内容
		this.getContent();
	}

	componentWillReceiveProps(nextProps){
		this.setState({ 
			haveLive: false
		});
		// 当切换uuid时，重新获取
		if(this.props.match.params.uuid !== nextProps.match.params.uuid){
			$('html,body').css({
				'background-color': '#F4F4F4'
			})
			this.getContentId(nextProps);
			this.getContent();
			this.statistics()
			this.control()
			setTimeout(() =>{
				this.initSwiper() 
			},300)
			
		}
	}
	
	componentWillUnmount() {
		// 在组件卸载前清空 data.list
		this.setState({ data: {} }, () => {
			console.log('组件卸载前data.list的状态:', this.state);
		});
	}

	//设置video的url
	setVideoUrl =()=>{
		const {data} = this.state
		data.list.forEach((item, index) => {
			if (item.module_type / 1 === 2) { // 地图模块
				this.initMap()
			} else if (item.module_type / 1 === 4) { // 置顶直播模块
				let video_url = ''
				let video_cover = ''
				item.manuscript_list.forEach((liveItem, liveIndex) => {
					video_url = liveItem.row.ext_data.video_url
					video_cover = liveItem.row.cover
				})
				this.setState({
					haveLive: true,
					video_cover:video_cover
				},()=>this.playVideo(video_url))
			}
			
		})
	}

	// shouldComponentUpdate() {
	//
	// }
	// 描述
	setDesc = (type) => {
		if (type === 1) {
			this.setState({descType: true})
		} else if (type === 2) {
			this.setState({descType: false})
		}
	}
	//换算分钟前
	changeBeforeTime = (beforetime, time) => {
		const date = new Date().getTime()
		const diffTime = date / 1000 - beforetime //毫秒
		let h = 0
    let m = 0
    let s = parseInt(diffTime,0)
		m = parseInt(s / 60,0)
		h = parseInt(m / 60,0)
		if (h >= 1) {
			if (h >= 48) {
				return time
			} else if (h >= 24 && h < 48) {
				return '1天前'
			} else {
				return h + '小时前'
			}
		} else {
			return m + '分钟前'
		}
	}
	//换算时分秒
	changeTime = (time) => {
		let h = 0, i = 0, s = parseInt(time,0)
		if (s > 60) {
			i = parseInt(s / 60,0)
			s = parseInt(s % 60,0)
		}
		if (i > 60) {
			h = parseInt(i / 60,0)
			i = parseInt(i % 60,0)
		}
		// 补零
		var zero = function (v) {
			return (v >> 0) < 10 ? "0" + v : v;
		}
		if (h === 0) {
			return [zero(i), zero(s)].join(':')
		} else {
			return [zero(h), zero(i), zero(s)].join(':')
		}
	}
	//跳转导航
	scrollDetail = (module_id) => {
		const id = '#' + module_id
		const div = $(id)[0]
		$('html,body').scrollTop(0).animate({scrollTop: $(div).offset().top}, 1000)
		return false;// 返回false可以避免在原链接后加上#
	}

	playVideo = (url) => {
		if (this.liveSource.current) {
		  this.liveSource.current.src = url;
		  this.livePlayer.current.load();
		  setTimeout(() => {
			this.livePlayer.current.play();
		  }, 1000);
		} else {
		  console.error('Refs not available yet.');
		}
	  };

	//人物跳转链接
  jumpUrl = (url) =>{
	  if(url){
	    window.location.href = url
    }else {
	    return
    }
  }
	// 控制播放
	control = (fal) => {
		const timestamp = new Date().getTime();
		// const timestamp = 1;
		//时间线轮播图
		setTimeout(function() {
			var mySwiper = new window.Swiper('.hotspot-swiper', {
					direction: 'horizontal', //横向切换选项
					loop: false, //循环模式选项
					slidesPerView: 'auto'
			});
		}, 2000);
		setTimeout(() => {
			$(".video-es").each(function (index, element) {
					var videoUrl = $(this).attr("src");
					var videoCover = $(this).attr("poster");
					const playerId  = $(this).attr('id')
					var video = document.getElementById(playerId);
					// 重新绑定事件监听器
					video.addEventListener('play', function onPlay() {
						nameAllPause(this.id)
						pauseAll()
					});
					// if (videoUrl) {
					// 		if (videoUrl.split(".").pop() === 'm3u8') {
					// 				var video = '<video id="my-video' + index + timestamp +'" class="video-js vjs-big-play-centered" controls preload="auto" width="100%" poster="' + videoCover + '"'
					// 						+ 'data-setup="{}" src="' + videoUrl + '">'
					// 						+ '<source src="' + videoUrl + '" type="application/x-mpegURL" />'
					// 						+ '</video>';
					// 				$(this).replaceWith(video);
					// 		} else {
					// 				var video = '<video id="my-video' + index + timestamp + '" class="video-js vjs-big-play-centered" controls preload="auto" width="100%" poster="' + videoCover + '"'
					// 						+ 'data-setup="{}" src="' + videoUrl + '">'
					// 						+ '<source src="' + videoUrl + '" type="video/mp4" />'
					// 						+ '<source src="'+ videoUrl +'" type="video/webm" />'
					// 						+ '<source src="'+ videoUrl +'" type="video/ogg" />'
					// 						+ '</video>';
					// 				$(this).replaceWith(video);
					// 		}
					// 		const playerId = 'my-video' + index + timestamp
					// 		// const player = window.videojs(playerId);
					// 		var video = document.getElementById(playerId);
					// 		// video.removeEventListener('play',function(){});
							
					// 		// 重新绑定事件监听器
					// 		video.addEventListener('play', function onPlay() {
					// 			nameAllPause(this.id)
					// 			pauseAll()
					// 		});
							
					// 		// 确保视频元素加载完成后再绑定事件
					// 		// player.ready(() => {
					// 		// 	// 移除旧的事件监听器
					// 		// 	player.off('play', function() {
					// 		// 		console.log('Video is playing!');
					// 		// 	})
					// 		// 	player.on("play", function () {
					// 		// 			console.log(123)
					// 		// 			nameAllPause(this.id_)
					// 		// 			pauseAll()
					// 		// 	})
					// 		// })
					// }
			});
			var audios = document.getElementsByTagName("audio");
			function pauseAll() {
					var self = this;
					console.log(self);
					[].forEach.call(audios, function (i) {
							i !== self && i.pause();
							console.log(i !== self && i.pause())
					})
			}
			[].forEach.call(audios, function (i) {
					i.addEventListener("play",function(){
							console.log(i)
							pauseAll.bind(i)()
							nameAllPause()
					}.bind(i));
			})
			function nameAllPause(params) {
					$('.video-es').each(function(index, element) {
						const playerId  = $(this).attr('id')
						if(playerId !== params || params=== undefined){
								// console.log(params)
								// window.videojs(playerId).pause();
								document.getElementById(playerId).pause()
								console.log(playerId)
								// pauseAll()
						}
					})
			}
		}, 200);
	}
	// 点击选择加载列表
	selectList = (currentOrder) => {
		$.ajax({
			type: 'get',
			url: API.special_detail,
			async: false,
			headers: {
				version: 'v103'
			},
			data: {
				uuid: this.state.uuid,
        order: currentOrder,
			},
			dataType: 'json'
		}).done((res) => {
			if (res.code == 0 || res.errorCode == 0) {
				this.setState({
					data: res.data,
					lisId : '',
					paixuBoolue: !this.state.paixuBoolue
				})
				this.control()
			} else {
				Toast.fail(res.msg || res.error);
			}
		});
	}

	render() {
		const {data, uuid, name, haveLive, descType,video_cover, lisId, paixuBoolue} = this.state;
		const timestamp = new Date().getTime();

		return (
			<div className="newsubject-box">

				{/*头部*/}
				<Header name={name} uuid={uuid}/>

				{/*专题头部*/}
				{data.focus_list && data.focus_list.length > 0 ? (
					//显示轮播图
					<div className="sicSwiper-container" id="subject_swiper">
						<div className="swiper-wrapper" id="subject_list">
							{
								data.focus_list.map((item, index) => { 
									return (
										<div className="swiper-slide" key={index}>
											<a href={item.special_focus_url} target="_blank" onClick={(e) => {
												e.preventDefault(); 
												window.location.href = item.special_focus_url; 
											}}> 
												<div className="sicSwiper-img" style={{backgroundImage: 'url(' + item.special_focus_cover + ')'}} key={index}></div>
												<p className="sicSwiper-text">{item.special_focus_title}</p>
												<div className='swiper-zhezhao'></div>
											</a>
										</div>
									)	
								})
							}
						</div>
						{/*前进后退*/}
						{/* <div className="swiper-button-prev"></div>
						<div className="swiper-button-next"></div> */}
						{/*页码*/}
						<div className="swiper-pagination"></div>
					</div>
				) :  haveLive ? (
					//显示直播
					<div className="subject-live-box">
						<video ref="live"
							id="live"
							playsInline="true"
							webkit-playsinline="true"
							x5-playsinline="true"
							controls
							preload="auto"
							poster={video_cover}
							loop>
							<source id="liveSource" ref="liveSource" src=""></source>
						</video>
					</div>
				) : (
					// 显示封面图
					<img className="newsubject-head-box" alt="头部图片" src={data.ext_data.inner_cover}/> 
				)}

				{/*描述*/}
				<div className="newsubject-desc">
					{data.desc.length >= 64 && !descType ? data.desc.substring(0, 63) : data.desc}
					{data.desc.length >= 64 && !descType ?
						<span onClick={this.setDesc.bind(this, 1)} className="descBtn">
							<span className="descIcon"></span>
							展开</span> :
							data.desc.length >= 64 ?
						<p onClick={this.setDesc.bind(this, 2)} className="descBtn">收起</p> : ''
					}
				</div>

				{/*专题导航*/}
				<ul className="newsubject-menu">
					{data.list.length > 0 ? data.list.map((item, index) => {
					  if(item.module_type/1 !== 4){
              			return  <li key={index} 
								    className="menuBox"
                         			onClick={this.scrollDetail.bind(this, item.module_id)}
              					>{item.module_name}
								</li>
            }
							})
						 : ''
					}
				</ul>

				{/*专题列表*/}
				<div className="new-subject-box">
					{/*专题题目*/}
					{/*<div className="newsubject-title">*/}
					{/*<div className="title" style={{*/}
					{/*overflow: 'hidden',*/}
					{/*textOverflow: 'ellipsis',*/}
					{/*display: '-webkit-box',*/}
					{/*'WebkitLineClamp': '2',*/}
					{/*'WebkitBoxOrient': 'vertical',*/}
					{/*}}>{data.desc}</div>*/}
					{/*</div>*/}
					{/*专题列表*/}
					<div className="newsubject-list">
						{
							data.list.map((item, index) => {
								switch (parseInt(item.module_type)) {
									case 2:             //地点
										return (
											<div className="newsubject-position-box" id={item.module_id} key={index}>
												<div className="position-text"><span className="red_line"></span>{item.module_name}</div>
												<div className="positionItem">
													{/*地图*/}
													<div className="map">
														<div id="container"></div>
													</div>
												</div>
											</div>
										)
										break;
									case 3:             //人物
										return (
											<div className="newsubject-person-box" id={item.module_id} key={index}>
												<div className="person-text"><span className="red_line"></span>{item.module_name}</div>
												<div className="person-list">
													{/*新闻列表*/}
													{
														item.person_list.map((person_item, person_index) => {
															return (
																<div className="personItem" key={person_index} onClick={this.jumpUrl.bind(this,person_item.relate_url)}>
																	<div className="left" style={{
																		backgroundImage: 'url(' + person_item.head_image + ')'
																	}}></div>
																	<div className="right">
																		<div
																			className="name">{person_item.user_name}</div>
																		<div className="text" style={{
																			overflow: 'hidden',
																			textOverflow: 'ellipsis',
																			display: '-webkit-box',
																			'WebkitLineClamp': '2',
																			'WebkitBoxOrient': 'vertical',
																		}}>{person_item.keyword}</div>
																	</div>
																</div>
															)
														})
													}
												</div>
											</div>
										)
										break;
									case 5:   //普通稿件模块
										return (
											<div className="newsubject-normal-box" id={item.module_id} key={index}>
												<div className="normal-text"><span className="red_line"></span>{item.module_name}</div>
												<div className="normal-list">
													{(item.manuscript_list.length > 6 && !this.state.normalType ?
														item.manuscript_list.slice(0, 6) : item.manuscript_list).map((normal_item, normal_index) => {
														return <div className="newsubject-normal-item" key={normal_index}
																				onClick={this.goDetail.bind(this, normal_item)}>
															<DetailBtn normal_item={normal_item}
																				 changeTime={this.changeTime}
                                         goDetail={this.goDetail}
																				 changeBeforeTime={this.changeBeforeTime}></DetailBtn>
														</div>
													})}
												</div>
												{item.manuscript_list.length > 6 && !this.state.normalType ?
													<div className="viewMoreNormal" onClick={() => this.setState({normalType: true})}>查看更多
														></div> : ''}
											</div>
										)
										break;
									case 6:             //视频组
										return (
											<div className="newsubject-video-box" id={item.module_id} key={index}>
												<div className="video-text"><span className="red_line"></span>{item.module_name}</div>
												<div className="video-list">
													{/*视频列表*/}
													{(item.manuscript_list.length > 12 && !this.state.videoType ?
														item.manuscript_list.slice(0, 12) : item.manuscript_list).map((manu_item, manu_index) => {
														return (
															<div className="manuItem"
																	 onClick={this.goDetail.bind(this, manu_item)}
																	 key={manu_index}>
																<div className="manuCover">
																	<img alt="封面图" src={manu_item.row.cover}/>
																	<div className="manuTimeBox">
																		<span className="play-icon"></span>
																		{manu_item.type/1 !==6 ? <span>{this.changeTime(manu_item.row.ext_data.duration)}</span> : ''}
																	</div>
																</div>
																<div className="manuTitle line_2">{manu_item.row.title}</div>
															</div>
														)
													})
													}
												</div>
												{item.manuscript_list.length > 12 && !this.state.videoType ?
													<div className="viewMoreVideo" onClick={() => this.setState({videoType: true})}>查看更多
														></div> : ''}
											</div>
										)
										break;
									case 7:             //时间
										return (
											<div className="newsubject-day-box" key={index} id={item.module_id}>
												{/*时间*/}
												<div className="newsubject-day-title">
													<span className="red_line"></span>{item.module_name}
												</div>
												{/*时间线*/}
												{
													item.event_list.map((time_item, time_index) => {
														return (
															<div className="time_box" key={time_index}>
																<p className="time_title">{time_item.time}</p>
																<p className="time_content">{time_item.content}</p>
															</div>
														)
													})
												}
											</div>
										)
										break;
									case 8:
										return(
											<div className="newsubject-day-box" key={index} id={item.module_id}>
												{
													item.module_id == lisId && paixuBoolue == true ? <div className="overlay"></div> : ""
												}
												<div className="paixu_right" onClick={() => this.setState({lisId : item.module_id, paixuBoolue: !paixuBoolue})}></div>
												{
													item.module_id == lisId && paixuBoolue == true ?
													<div className="paixu_right_nav">
															<p className="zhongyao" data-id={item.module_id} onClick={this.selectList.bind(this, 'importan')}>只看重要</p>
															<p className="daoxu" data-id={item.module_id} onClick={this.selectList.bind(this, 'desc')}>倒序</p>
															<p className="zhengxu" data-id={item.module_id} onClick={this.selectList.bind(this, 'asc')}>正序</p>
													</div>
													: ''
												}
												<div className="newsubject-day-title flex_aline_center"><span className="red_line"></span>{item.module_name}</div>
												<div className="time_box_paixu">{item.event_list.map((time_item, time_index) => {
													return (
														<div className="time_box" key={time_index}>
															{time_item.node_desc != null ? (
																time_item.outside_url != "" ? (
																	<div>
																		<a href={time_item.outside_url}>
																			<p className="time_title" style={{cursor: 'pointer'}}><i></i>{time_item.node_desc}</p>
																		</a>
																		<a href={time_item.outside_url}>
																		{
																			time_item.event_title != '' ? (
																				<p className="time_big_title">{time_item.event_title}</p>
																			) : ''
																		}
																			<p className="time_miaosu_title">{time_item.content}</p>
																		</a>
																	</div>
																) : (
																	<Fragment>
																		<a href={time_item.url}>
																			<p className="time_title" onclick="goHTML('article','1695360625122712')"><i></i>{time_item.node_desc}</p>
																			<p className="time_big_title" style={{cursor: 'pointer'}}>{time_item.event_title ? time_item.event_title : ''}</p>
																			<p className="time_miaosu_title" style={{cursor: 'pointer'}}>{time_item.content}</p>
																		</a>
																		
																	</Fragment>
																)
															) : (
																''
															)}
															{/* 图片 */}
															{time_item.img_data.length > 1 ? (
																<div className="time_images">
																	<div className="swiper-container hotspot-swiper">
																		<div className="swiper-wrapper">
																		{
																			time_item.img_data.map((img_item, img_index) => {
																				return (
																					<div className="swiper-slide swiper-slide-duplicate" key={img_index}>
																							{
																								time_item.outside_url != "" ? (
																									<a href={time_item.outside_url} key={img_index}>
																											<div className="hotspot-swiper-href" style={{background: `url(${img_item.image_url}) center center / cover no-repeat`}}>
																											</div>
																											<p className="moreimg_desc">{img_item.desc}</p>
																									</a>
																								) : time_item.url != "" ? (
																									<a href={time_item.url} key={img_index}>
																											<div className="hotspot-swiper-href" style={{background: `url(${img_item.image_url}) center center / cover no-repeat`}}>
																											</div>
																											<p className="moreimg_desc">{img_item.desc}</p>
																									</a>
																								) : (
																									<a href="javascript:;">
																											<div className="hotspot-swiper-href" style={{background: `url(${img_item.image_url}) center center / cover no-repeat`}}>
																											</div>
																											<p className="moreimg_desc">{img_item.desc}</p>
																									</a>
																								)
																							}
																					</div>
																				)
																			})
																		}                                      
																		</div>
																	</div>
																</div>
															) : time_item.img_data.length != '' ? (
																<div className="one_image">
																	{
																		time_item.outside_url != "" ? (
																			<a href={time_item.outside_url}>
																					<img src={time_item.img_data[0].image_url}/>
																					<p className="image_miaoshu">{time_item.img_data[0].desc}</p>
																			</a>
																		) : time_item.url != "" ? (
																			<a href={time_item.url}>
																					<img src={time_item.img_data[0].image_url}/>
																					<p className="image_miaoshu">{time_item.img_data[0].desc}</p>
																			</a>
																		) : (
																			<a href="javascript:;">
																					<img src={time_item.img_data[0].image_url}/>
																					<p className="image_miaoshu">{time_item.img_data[0].desc}</p>
																			</a>
																		)
																	}
																</div>
															) : ''}
															{/* 视频 */}
															{time_item.video_data.length != '' ? (
																time_item.video_data.map((video_item, video_index) => {
																	return (
																		<div className="video_lists">
																				<video id={`video${item.module_id}${time_index}${video_index}${timestamp}`} className="video-es pc_video vjs-big-play-centered" x-webkit-airplay="allow" poster={video_item.video_cover} webkit-playsinline playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true" preload="auto" src={video_item.video_url} controls="controls">
																						time_demo += "<source src={video_item.video_url} type={video_item.video_url.toLowerCase().indexOf('.m3u8') != -1 ? 'application/x-mpegURL' : 'video/mp4'}/>
																				</video>
																				<p className="image_miaoshu">{video_item.desc}</p>
																		</div>
																	)
																})
															) : ''}
															{/* 音频 */}
															{time_item.audio_data.length != '' ? (
																time_item.audio_data.map((audio_item, audio_index) => {
																	return (
																		<div class="audio_list">
																			<div class="audio">
																					<audio controls>
																							<source src={audio_item.audio_url} type="audio/mpeg" />
																							<source src={audio_item.audio_url} type="audio/ogg" />
																					</audio>
																					<p class="image_miaoshu">{audio_item.desc}</p>
																			</div>
																		</div>
																	)
																})
															) : ''}
														</div>
													)
												})}</div>
											</div>
										)
										break;
								}
							})
						}
					</div>

					<TopBtn type={1}/>

				</div>

				{/*打开APP按钮*/}
				<AppBtn name={this.state.name} uuid={this.state.uuid} style={{marginTop: '.78rem'}}
								text="打开北京东城App，阅读体验更佳"/>

			</div>
		);
	}

	getContentId(props) {
		// console.log(this.props);
		const {uuid} = props.match.params;
		if (uuid) {
			this.state.uuid = uuid
		}
	}

	getContent() {
		$.ajax({
			type: 'get',
			url: API.special_detail,
			async: false,
			headers: {
				version: 'v103'
			},
			data: {
				uuid: this.state.uuid,
			},
			dataType: 'json'
		}).done((res) => {
			if (res.code == 0 || res.errorCode == 0) {
				this.setState({
					data: res.data,
				})
				document.title = '专题 | ' + res.data.title;

				this.initWx({
					title: res.data.title,
					desc: res.data.desc,
				})
			} else {
				Toast.fail(res.msg || res.error);
			}
		});
	}

	//初始化轮播图
	initSwiper() {
		var _this = this;
		this.subject_swiper = new window.Swiper('#subject_swiper', {
			direction: 'horizontal',
			loop: true,
			initialSlide: 0,
			touchMoveStopPropagation: true,
			preventClicksPropagation: true,
			slidesPerView: 'auto',
			freeMode: false,
			autoplay: {
				delay: 2000, 
			},
	
			// 如果需要分页器
			pagination: {
				el: '.swiper-pagination',
			},
		
			// 如果需要前进后退按钮
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		
			// 如果需要滚动条
			scrollbar: {
				el: '.swiper-scrollbar',
			},
	
			//   on: {
			// 	slideChangeTransitionEnd: function () {
			// 	  _this.setState({
			// 		curSwiperIndex: this.realIndex//切换结束时，告诉我现在是第几个slide
			// 	  })
			// 	  var cur = _this.state.data.content[this.realIndex];
			// 	  var cur_w = parseFloat(cur.width);
			// 	  var cur_h = parseFloat(cur.height);
			// 	  var h = cur_h / cur_w * 7.5
			// 	  $('#subject_swiper').css({
			// 		height: h + 'rem'
			// 	  })
			// 	},
			//   },
			
		})
	  }

	// 初始化地图
	initMap() {
		const {data} = this.state
		var latitude = -1;
		var longitude = -1;
		for (var i = 0; i < data.list.length; i++) {
			var temp = data.list[i];
			if (parseInt(temp.module_type) === 2) {
				latitude = parseFloat(temp.module_data.latitude)
				longitude = parseFloat(temp.module_data.longitude)
				break;
			}
		}
		if (latitude === -1) {
			return
		}

		var map = new window.AMap.Map('container', {
			center: [longitude, latitude],
			zoom: 11
		});

		// 创建 AMap.Icon 实例：
		var icon = new window.AMap.Icon({
			size: new window.AMap.Size(34, 39),    // 图标尺寸
			image: API.map_icon,  // Icon的图像
			// imageOffset: new window.AMap.Pixel(0, -60),  // 图像相对展示区域的偏移量，适于雪碧图等
			imageSize: new window.AMap.Size(34, 39)   // 根据所设置的大小拉伸或压缩图片
		});

		// 创建一个 Marker 实例：
		var marker = new window.AMap.Marker({
			position: new window.AMap.LngLat(longitude, latitude),
			// offset: new window.AMap.Pixel(-10, -10),
			icon: icon, // 添加 Icon 图标 URL
			title: '北京'
		});

		// 将创建的点标记添加到已有的地图实例：
		map.add(marker);
	}
	// 跳转详情
	goDetail(item) {
		switch (parseInt(item.type)) {
			case 1:     //图文
				this.props.history.push('/detail/1/' + item.uuid)
				break;
			case 2:     //视频
				this.props.history.push('/detail/2/' + item.uuid + '/2')
				break;
			case 21:    //音频
				this.props.history.push('/detail/21/' + item.uuid + '/21')
				break;
			case 3: // 专题
			  if(item.row.special_type/1 ===1){
					// 常规专题
          this.props.history.push('/subject/1/' + item.uuid)
        }else if(item.row.special_type/1 ===2){
					// 时间线专题
          this.props.history.push('/subject/2/' + item.uuid)
        }else if(item.row.special_type/1 ===3){
					// 新型专题
          this.props.history.push('/newSubject/' + item.uuid)
        }
				break;
			case 4:     //图说
				this.props.history.push('/detail/3/' + item.uuid)
				break;
			case 6:     //直播
				this.props.history.push('/detail/2/' + item.uuid + '/6')
				break;
      case 50: // 外链
        window.location.href = item.row.ext_data.article_url
        break;
		}
	}

	statistics(share) {
		var op = share ? 'share' : 'pv';
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = API.pv + '?xm=bjnews&wz=article_detail&op=' + op + '&pt=web&unique_id=' + this.state.uuid;     //填自己的js路径
		$('body').append(script);
	}

	initWx(obj) {
		//分享
		var wxconfig = new window.WxConfig();
		// console.log(window.location.href);
		wxconfig.init({
			appid: API.appid,
			url: window.location.href,
			title: obj.title,
			desc: obj.desc || API.share_des,
			link: window.location.href,
			imgUrl: API.share_img,
			successCallback: this.statistics.bind(this, true)
		});
	}

}

export default Subject;


// WEBPACK FOOTER //
// ./src/pages/NewSubject/newSubject.js